import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';
import { type FeedFlowItem } from '@src/services/interface';
import { jumpPageUrl, getQuery } from '@src/utils/index';
import { volcengineAndH5Statistics } from '@ifeng-fe/mobile_statistics';

type ForwardShortProps = {
    content: FeedFlowItem | null | undefined;
};

const ForwardShort = ({ content }: ForwardShortProps) => {
    const faceUrl = content?.author?.avatar;
    const userName = content?.author?.nickname;
    const text = content?.post?.text?.content || '';
    const hasLink = content?.post?.hasLink;
    const guid = content?.guid || '';
    const id = content?.id || '';
    const allMark = [];
    // @ts-ignore
    const postLink = content?.post?.link?.shareUrl || content?.post?.link?.url || '';
    const linkText = content?.post?.link?.title;

    if (content?.post?.hasImage) {
        allMark.push('[图片]');
    }
    if (content?.post?.hasVideo) {
        allMark.push('[视频]');
    }
    if (content?.post?.hasVote) {
        allMark.push('[投票]');
    }

    const jumpHandle = () => {
        const userId = getQuery(window.location.href, 'userId') || '';

        volcengineAndH5Statistics({
            behavior: 'action',
            type: 'sharepage_link_button',
            button_name: 'a',
            user_id: userId,
        });
        jumpPageUrl('personal', guid);
    };

    return text ? (
        <div className={styles.articleProphesy}>
            {(userName || faceUrl) && (
                <div className={styles.head} onClick={jumpHandle}>
                    {faceUrl && <img className={styles.face} src={formatImageWebpAuto(faceUrl, 40, 40)} />}
                    {userName && <div className={styles.username}>{userName}</div>}
                </div>
            )}
            <div
                className={styles.feed}
                onClick={() => {
                    jumpPageUrl('article', id);
                }}>
                <div className={styles.text}>
                    {text}
                    {allMark.map((item) => (
                        <span key={item} className={styles.hightLight}>
                            {item}
                        </span>
                    ))}
                </div>
            </div>
            {hasLink && linkText && (
                <div
                    onClick={() => {
                        location.href = postLink;
                    }}
                    className={styles.link}>
                    {linkText}
                </div>
            )}
        </div>
    ) : null;
};

export default errorBoundary(ForwardShort);
